module.exports = __webpack_public_path__ + "static/stef-3094a5770640b1cf22e3799a0a549e12.jpg";